import PassengerFlowDay from './src/PassengerFlow/PassengerFlowDay.vue'
import PassengerFlowMonth from './src/PassengerFlow/PassengerFlowMonth.vue'
import PassengerFlowYear from './src/PassengerFlow/PassengerFlowYear.vue'
import TourPortrayal from './src/TourPortrayal/TourPortrayal.vue' //游客画像

let views = {
    PassengerFlowDay,
    PassengerFlowMonth,
    PassengerFlowYear,
    TourPortrayal
};

export default views;